import React from 'react';

const cohortLabels = { tc: 'Traffic Control', imp: 'Implement', combo: 'Combo' };

export default function PracticalProjectEditor({ task, onChange, readOnly = false }) {
  const entries = task.assessorChecklist || [];
  const update = (id, changes) => onChange({ assessorChecklist: entries.map(entry => entry.id === id ? { ...entry, ...changes } : entry) });
  return <section className="courseBuilderChecklist">
    <h3>{task.name || 'Practical project'} outcome matrix</h3>
    <p>Trainer-facing marking. Project S marks every applicable criterion S; learners only review results and sign their declaration.</p>
    {entries.map(entry => <fieldset key={entry.id} disabled={readOnly} style={{ marginBottom: 16, border: '1px solid #cbd5e1', borderRadius: 10, padding: 16 }}>
      <legend>Task {entry.numberLabel}</legend>
      <label style={{ display: 'block' }}>Task and child criteria
        <textarea rows={5} style={{ width: '100%', boxSizing: 'border-box' }} value={entry.text || ''} onChange={event => update(entry.id, { text: event.target.value })} />
      </label>
      <label style={{ display: 'block', marginTop: 12 }}>Assessment benchmark
        <textarea rows={7} style={{ width: '100%', boxSizing: 'border-box' }} value={entry.benchmark || ''} onChange={event => update(entry.id, { benchmark: event.target.value })} />
      </label>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 12 }}>
        {Object.entries(cohortLabels).map(([cohort, label]) => <label key={cohort}>
          <input type="checkbox" checked={(entry.cohorts || []).includes(cohort)} onChange={event => update(entry.id, {
            cohorts: event.target.checked ? [...(entry.cohorts || []), cohort] : (entry.cohorts || []).filter(item => item !== cohort),
          })} /> {label}
        </label>)}
      </div>
    </fieldset>)}
    {!entries.length && <p>No project matrix has been imported for this assessment.</p>}
  </section>;
}
